/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl, checkIsActive } from '../../../../_helpers';
import { ReactComponent as Arrow } from '../../../../../../src/app/assets/chevron-right-solid.svg';

export function OverviewLinks({ layoutProps }) {
    const location = useLocation();
    const [customizationDropDown, setCustomizationDropDown] = useState(false);
    const getMenuItemActive = (...urls) => {
        return checkIsActive(location, ...urls) ? ' menu-item-active menu-item-open ' : '';
    };

    return (
        <>
            <div className={`menu-nav ${layoutProps.ulClasses}`} style={{ padding: '0 0' }}>
                <li
                    className={`menu-item ${getMenuItemActive(
                        '/overview',
                        '/multi-overview',
                    )}`}
                    aria-haspopup='true'
                >
                    <div
                        className={`menu-link ${customizationDropDown ? 'menu-show' : ''}`}
                        onClick={() => setCustomizationDropDown(!customizationDropDown)}
                    >
                        <span className='svg-icon menu-icon svg-icon-1'>
                            <SVG src={toAbsoluteUrl('/assets/Dashboard.svg')} />
                        </span>
                        <span className='menu-text'>Overview</span>
                        <span>
                            <Arrow className='arrow-icon' />
                        </span>
                    </div>
                    <div className={`js-dropdown-list ${customizationDropDown ? 'js-show' : 'js-hide'}`}>
                        <ul>
                            <li className={`menu-item ${getMenuItemActive('/overview')}`} aria-haspopup='true'>
                                <NavLink className='menu-link' to='/overview'>
                                    <span className='menu-text'>Overview</span>
                                </NavLink>
                            </li>
                            <li className={`menu-item ${getMenuItemActive('/multi-overview')}`} aria-haspopup='true'>
                                <NavLink className='menu-link' to='/multi-overview'>
                                    <span className='menu-text'>Multi Merchant Overview</span>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </li>
            </div>
        </>
    );
}
